import React from "react";

function View({
  supportHref,
  shareHref = "/actions/refresh?modal[type]=share",
}) {
  return (
    <div className={`Metrics-Foot${supportHref ? "" : " end"}`}>
      {supportHref && (
        <a className="support metric-anchor-foot" href={supportHref}>
          <div className="metric-anchor-container">
            <img src="/img/icons/help-icon.webp" alt="icon" />
            Need Help?
          </div>
        </a>
      )}
    </div>
  );
}

export default View;
